/**
 * 请求相关常量
 */

/** API 成功状态码 */
export const API_SUCCESS_CODE = '200';

/** HTTP 状态码 */
export const HTTP_STATUS = {
  OK: 200,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_ERROR: 500,
} as const;

/** 默认请求超时时间 (毫秒) */
export const DEFAULT_TIMEOUT = 10000;

/** 默认加密请求头名称 */
export const DEFAULT_ENCRYPT_HEADER = 'X-Encrypted';
export const DEFAULT_TIMESTAMP_HEADER = 'X-Timestamp';
export const DEFAULT_SIGNATURE_HEADER = 'X-Signature';

/** 默认未授权状态码 */
export const DEFAULT_UNAUTHORIZED_CODES = [
  HTTP_STATUS.UNAUTHORIZED,
  HTTP_STATUS.FORBIDDEN,
] as const;

/** 未授权状态码字符串集合（预计算，避免每次调用时重复 String() 转换） */
const UNAUTHORIZED_CODES = new Set(
  DEFAULT_UNAUTHORIZED_CODES.map((code) => String(code)),
);

/**
 * 判断业务状态码是否为未授权
 *
 * @param code - 业务状态码
 * @returns 是否为未授权状态码 (401 / 403)
 */
export function isUnauthorizedCode(code: string | number | undefined): boolean {
  if (code === undefined) return false;
  return UNAUTHORIZED_CODES.has(String(code));
}

/**
 * 创建未授权状态码检测器
 *
 * @param customCodes - 业务自定义未授权码
 * @param includeDefault - 是否包含默认 401/403
 */
export function createUnauthorizedCodeChecker(
  customCodes: Array<string | number> = [],
  includeDefault: boolean = true,
): (code: string | number | undefined) => boolean {
  const codeSet = new Set<string>();
  if (includeDefault) {
    for (const code of DEFAULT_UNAUTHORIZED_CODES) {
      codeSet.add(String(code));
    }
  }
  for (const code of customCodes) {
    codeSet.add(String(code));
  }

  return (code: string | number | undefined): boolean => {
    if (code === undefined) return false;
    return codeSet.has(String(code));
  };
}
